export const version = '2.22.3';
//# sourceMappingURL=version.js.map